export default __webpack_public_path__ + "static/media/news4.269e9db8.png";